import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  PLATFORM_ID,
  signal,
  WritableSignal
} from '@angular/core';
import {AlgoliaService} from '@core/services/algolia.service';
import {AlgoliaState} from '@core/interfaces/algolia-state';
import {AlgoliaProduct} from '@core/interfaces/algolia-product';
import {HitsContainerComponent} from './components/hits-container/hits-container.component';
import {SearchboxComponent} from './components/searchbox/searchbox.component';
import {CookieService} from '@core/services/cookie.service';
import {isPlatformBrowser} from '@angular/common';
import {InstantSearchOptions} from 'instantsearch.js/es/types';
import {InstantSearchComponent} from '@core/instantsearch/components/instantsearch.component';

@Component({
  selector: 'app-quicksearch',
  templateUrl: './quicksearch.component.html',
  styleUrls: ['./quicksearch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HitsContainerComponent, SearchboxComponent, InstantSearchComponent]
})
export class QuicksearchComponent {
  private algoliaService = inject(AlgoliaService);
  private changeDetector = inject(ChangeDetectorRef);
  private cookieService = inject(CookieService);
  private platformId = inject(PLATFORM_ID);


  state: WritableSignal<AlgoliaState|undefined> = signal(undefined);

  searchBoxIsOnFocus = signal(false);
  isResultsVisible = signal(false);

  hits = computed(() => {
    const state = this.state();
    if (!state) {
      return [];
    }

    const queryID = state.results?.queryID;
    let hits = (state.results?.hits || []) as AlgoliaProduct[];
    hits = hits.map((hit, index) => {
      hit.__position = index + 1;
      hit.__queryID = queryID;
      return hit;
    })
    return hits.filter(hit => !hit.pageWhitelist || hit?.pageWhitelist?.length === 0);
  })

  searchClient = this.algoliaService.searchClient();

  searchConfig = computed(() => {

    const searchClient = this.searchClient();

    const indexName = this.algoliaService.algoliaSettings()?.indexName;

    if (!searchClient || !indexName) {
      return undefined;
    }

    const _config: InstantSearchOptions = {
      indexName: indexName,
      searchClient: searchClient,
      searchFunction: (helper) => {
        if (helper.state.query != '') {
          helper.search();
        }
      },
    };

    if (isPlatformBrowser(this.platformId)) {
      const useCookie = !!this.cookieService.get('_ALGOLIA');
      _config.insights = {
        insightsInitParams: [{
          useCookie,
        }]
      }
    }

    return _config;
  });

  setSearchboxFocus(focus: boolean) {
    this.searchBoxIsOnFocus.set(focus)
  }

  displaySearchContainer(event: boolean) {
    this.isResultsVisible.set(event)
  }

  disableResultsVisibility() {
    if (!this.isResultsVisible()) {
      return;
    }
    if (!this.searchBoxIsOnFocus()) {
      this.isResultsVisible.set(false);
      this.changeDetector.detectChanges();
    }
  }

  stateChange(event: any) {
    if (event?.results) {
      this.state.set(event);
    }
  }
}
